import packageJson from "@root/package";

export const EXPRESSION_VALIDATOR_VERSION: string =
    packageJson.dependencies['@logex/expression-validator'];
